export default __webpack_public_path__ + "static/media/Comp 2_00045.98399ffa.png";